import Header from "../header";
import Menu from "../menu";
import Main from '../main';
import { ReactNode } from "react";
import { LayoutDevelopment } from './styled';
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import useDisclouse from "../../hooks/useDisclouse";
export interface IChildren {
  children?: ReactNode
  title?: string
}

const ErrorComponentBounder = ({ error, resetErrorBoundary }) => {
  return (
    <>
      <div role="alert">
        <p>Something went wrong:</p>
        <pre style={{ color: "red" }}>{error.message}</pre>
      </div>
    </>
  )
}

export default function Layout(props: IChildren) {

  const { isOpen, onClose, onOpen } = useDisclouse()

  return (
    <LayoutDevelopment>
      <Header onOpen={onClose} title={props?.title || ''} />
      <Menu isOpen={isOpen} onClose={onClose} onOpen={onOpen} />
      <Main>
        <ErrorBoundary fallbackRender={ErrorComponentBounder}>
          <Outlet />
        </ErrorBoundary>
      </Main>
    </LayoutDevelopment>
  )
}
